import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  TreatmentMaster,
  TreatmentMasterPayload,
} from "@project/types/treatment-master";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/treatment-master`;
const SILENT: RequestConfig = { showNotification: false };

class TreatmentMasterService {
  listTreatmentMasterPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<TreatmentMaster>> => {
    return fetchListPage<TreatmentMaster>(`${BASE}/`, query);
  };

  getTreatmentMaster = async (
    id: number
  ): Promise<TreatmentMaster | undefined> => {
    const data = await get<ApiItemResponse<TreatmentMaster> | TreatmentMaster>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  createTreatmentMaster = async (
    payload: TreatmentMasterPayload
  ): Promise<TreatmentMaster | undefined> => {
    const data = await post<
      ApiItemResponse<TreatmentMaster> | TreatmentMaster,
      TreatmentMasterPayload
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  updateTreatmentMaster = async (
    id: number,
    payload: Partial<TreatmentMasterPayload>
  ): Promise<TreatmentMaster | undefined> => {
    const data = await patch<
      ApiItemResponse<TreatmentMaster> | TreatmentMaster,
      Partial<TreatmentMasterPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  deleteTreatmentMaster = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const treatmentMasterService = new TreatmentMasterService();
